
import { defineComponent,computed } from 'vue';
import DemoPage from './pages/DemoPage.vue'
import './styles/global.css'

export default defineComponent({
  name: 'App',
  components: {
    DemoPage
  },
  provide() {
    return {
      setTheme: (isInverse: boolean) => {
        this.isInverse = isInverse;
        document.body.classList.toggle('theme-inverse', this.isInverse);
      },
      isThemeInverse: computed(() => this.isInverse)
    };
  },
  data() {
    return {
      isInverse: false
    }
  }
});
